import SnoozeService from '../service/SnoozeService';
import { DateTime } from '~/notify/settings/__modules__/utils/DateTime';
import EnvService from '~/notify/settings/__modules__/utils/Env';

export const SnoozeType = {
  Off: 0,
  OneHour: 1,
  TwoHour: 2,
  Util8AM: 3,
  Forever: 4,
};

const SNOOZE_OPTION = 'notiSnooze';

export default class SnoozeBiz {
  static async getSnoozeOption() {
    const result = await SnoozeService.getUserOptions(SNOOZE_OPTION);
    let option = { level: 0 };
    if (!result) {
      return option;
    } else {
      const optionResult = JSON.parse(result);
      option.level = optionResult.option;
      option.startDateTime = optionResult.startDateTime;
      option.endDateTime = optionResult.endDateTime;
      option.time = SnoozeBiz.getSnoozeTipTime(
        option.level,
        option.endDateTime,
      );
      return option;
    }
  }

  static async setSnoozeForOneHour() {
    const val = { option: 1 };
    await SnoozeService.setSnooze(val);
  }

  static async setSnoozeForTwoHour() {
    const val = { option: 2 };
    await SnoozeService.setSnooze(val);
  }

  static async setSnoozeForUtil8am() {
    const offset = EnvService.getTimeZoneOffset();
    const localOffset = EnvService.getLocalTimeZoneOffset();

    const now = Date.now();
    const theDate = new Date(now + (localOffset + offset) * 60 * 1000);
    const currentHour = theDate.getHours();
    if (currentHour >= 8) {
      theDate.setDate(theDate.getDate() + 1);
    }

    theDate.setHours(8);
    theDate.setMinutes(0);
    theDate.setMilliseconds(0);

    const endDateTime = theDate.getTime() - (localOffset + offset) * 60 * 1000;
    const val = { option: 3, endDateTime: endDateTime };
    await SnoozeService.setSnooze(val);
  }

  static async setSnoozeForever() {
    const val = { option: 4 };
    await SnoozeService.setSnooze(val);
  }

  static async setSnoozeOff() {
    const val = { option: 0 };
    await SnoozeService.setSnooze(val);
  }

  static isSnoozingTime(currentOption) {
    let level = currentOption.level;
    if (level === SnoozeType.Off) {
      return false;
    } else if (level === SnoozeType.Forever) {
      return true;
    } else if (
      level === SnoozeType.OneHour ||
      level === SnoozeType.TwoHour ||
      level === SnoozeType.Util8AM
    ) {
      const now = Date.now();
      return currentOption.endDateTime && currentOption.endDateTime - now > 0;
    } else {
      return false;
    }
  }

  static getSnoozeTipTime(level, endDateTime) {
    if (
      level === SnoozeType.OneHour ||
      level === SnoozeType.TwoHour ||
      level === SnoozeType.Util8AM
    ) {
      const endDate = new Date(endDateTime);
      const snoozeTime = DateTime(endDate.getTime(), 'time');
      return snoozeTime;
    } else {
      return '';
    }
  }
}
